module.exports = __webpack_public_path__ + "img/banner.a02d3e0c.jpg";